import { animate, state, style, transition, trigger } from '@angular/animations';

// export const dialogOpenAndLeave = trigger('slideInOut', [
//   state('void', style({ transform: 'scale(0)' })),
//   state('open', style({ transform: 'scale(1)' })),
//   state('closed', style({ transform: 'scale(0)' })),
//   transition('void => open', [animate('500ms cubic-bezier(.43,-0.33,.53,1.22)')]),
//   transition('open => closed', [animate('300ms cubic-bezier(.43,-0.33,.53,1.22)')]),
// ]);

export const dialogOpenAndLeave = trigger('slideInOut', [
  state('void', style({ transform: 'scale(0.5)', opacity: 0 })),
  state('open', style({ transform: 'scale(1)', opacity: 1 })),
  state('closed', style({ transform: 'scale(0.5)', opacity: 0 })),
  transition('void => open', [animate('500ms cubic-bezier(.43,-0.33,.53,1.22)')]),
  transition('open => closed', [animate('300ms cubic-bezier(.43,-0.33,.53,1.22)')]),
]);
